import { createFileRoute, redirect } from '@tanstack/react-router'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { Button } from '@/components/ui/button'

function ThrowOnRender(): never {
  throw new Error('sentry-test: intentional render error')
}

function SentryTestPage() {
  const [shouldThrow, setShouldThrow] = useState(false)

  const failMutation = useMutation({
    mutationKey: ['sentry-test-mutation'],
    mutationFn: (): Promise<void> =>
      Promise.reject(new Error('sentry-test: intentional mutation failure')),
  })

  const [queryEnabled, setQueryEnabled] = useState(false)
  useQuery({
    queryKey: ['sentry-test-query'],
    queryFn: (): Promise<void> =>
      Promise.reject(new Error('sentry-test: intentional query failure')),
    enabled: queryEnabled,
    retry: 0,
  })

  if (shouldThrow) return <ThrowOnRender />

  return (
    <div className="p-8 space-y-4">
      <h1 className="text-lg font-semibold">Sentry Test (dev only)</h1>
      <div className="flex gap-3">
        <Button data-testid="throw-render-error" onClick={() => setShouldThrow(true)}>
          Throw render error
        </Button>
        <Button
          data-testid="fire-mutation-failure"
          variant="outline"
          onClick={() => failMutation.mutate()}
        >
          Fire failing mutation
        </Button>
        <Button
          data-testid="fire-query-failure"
          variant="outline"
          onClick={() => setQueryEnabled(true)}
        >
          Fire failing query
        </Button>
      </div>
      {failMutation.isError && (
        <p className="text-sm text-destructive" data-testid="mutation-error-msg">
          Mutation failed (captured by Sentry)
        </p>
      )}
    </div>
  )
}

export const Route = createFileRoute('/sentry-test')({
  beforeLoad() {
    if (!import.meta.env.DEV) throw redirect({ to: '/' })
  },
  component: SentryTestPage,
})
